import React from 'react';
import styled from '@emotion/styled';
import { AutoSuggestInput, Row } from '../../../ui';

const InputWrap = styled.div`
	max-width: 600px;
`;

const items = [
	{ type: 'item' as const, key: '1', value: 'A' },
	{ type: 'item' as const, key: '2', value: 'B' },
	{ type: 'item' as const, key: '3', value: 'C' },
];

export const AutoSuggest = () => (
	<InputWrap>
		<h2 id="autosuggest">Auto suggest</h2>
		<Row>
			<AutoSuggestInput
				items={items}
				placeholder="I will suggest no matter what you type"
			/>
		</Row>
		<Row>
			<AutoSuggestInput
				items={items}
				placeholder="I have the placeholder as a label"
			/>
		</Row>
	</InputWrap>
);
